module.exports = __webpack_public_path__ + "static/media/CompetitionScienceIcon.3873dd8c.svg";